<script>
    import NauiSwitch from "../../../../naui/atoms/NauiSwitch.svelte";
    import NauiInput from "../../../../naui/atoms/NauiInput.svelte";
    import NauiSelect from "../../../../naui/atoms/NauiSelect.svelte";
    import NauiButton from "../../../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let parametros_step_3;

    let dispatch = createEventDispatcher();

     function next(){
        dispatch('next')
    }

    function prev(){
        dispatch('prev')
    }

</script>
<section>
    <fieldset>
        <legend>Datos del conductor</legend>
        <div class="box-l sx-1 mb-2">
            <p>¿El asegurado conducía el automóvil?</p>
            <NauiSwitch/>
        </div>
        <div class="grid-5 gap-1 mb-1">
            <NauiInput label="Nombre"/>
            <NauiSelect options="[]" label="Tipo de documento"/>
            <NauiInput label="No. Identificación"/>
            <NauiSelect label="Género" options="[]"/>
            <NauiSelect label="Afinidad con el asegurado" options={parametros_step_3.afinidad}/>
        </div>
        <div class="grid-5 gap-1 mb-1">
            <NauiInput type="email" label="Correo"/>
            <NauiInput type="text" label="Celular"/>
            <div class="col-2">
                <NauiInput type="text" label="Dirección"/>
            </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>Detalles del accidente</legend>
        <div class="grid-2 gap-1 mb-1">
            <NauiSelect label="Tipo de daño" options="[]"/>
            <NauiSelect label="Motivo del accidente" options="[]"/>
        </div>
        <textarea class="naui-input w-100 mb-2" style="min-height: 150px"
                  placeholder="Detalles del accidente (máximo 950 caracteres)"></textarea>
        <div class="box-l sx-1 mb-1">
            <p>¿Intervino la autoridad de tránsito?</p>
            <NauiSwitch/>
        </div>
        <textarea class="naui-input w-100 mb-2" style="min-height: 70px"
                  placeholder="Explique la razón (máximo 200 caracteres)"></textarea>
        <div class="grid-2 gap-1 mb-3">
            <NauiSelect label="Sucursal de reparación HDI" options="[]"/>
            <NauiSelect label="Taller de reparación" options="[]"/>
        </div>
        <hr>
        <div class="grid-2 gap-1 mb-1">
            <NauiSelect label="Responsable del accidente" options="[]"/>
        </div>
        <textarea class="naui-input w-100 mb-2" style="min-height: 150px"
                  placeholder="Observaciones (máximo 950 caracteres)"></textarea>
        <div class="box-l sx-1">
            <NauiButton caption="Regresar" mode="outline" color="accent" className="min-w-200px" on:click={prev}/>
            <NauiButton caption="Continuar" mode="solid" color="accent" className="min-w-200px" on:click={next}/>
        </div>
    </fieldset>
</section>